export default __webpack_public_path__ + "static/img-finish-products-0016b727707328fd62e78d967733493a.webp";